module.exports = __webpack_public_path__ + "apple_podcasts-25943576b2e788a78fab.svg";